<template>
  <div id="e-table">
    <table
      class="table-item"
      width="100%"
      border="0"
      cellspacing="0"
      cellpadding="0"
    >
      <thead class="table-head">
        <tr>
          <th class="head-item">核心指标</th>
          <th class="head-item">本月目标</th>
          <th class="head-item">当前完成</th>
          <th class="head-item">完成比例</th>
        </tr>
      </thead>
      <tbody class="table-body">
        <div class="vacancy"></div>
        <!-- <tr class="table-line" v-for="(item, index) in dig.closeRateData" :key="index"> -->
        <tr class="table-line" v-for="(item, index) in data" :key="index">
          <td class="body-lable">{{ item.dictLabel }}</td>
          <td class="body-lable">{{ item.indicatorValueA }}</td>
          <td class="body-lable">{{ item.indicatorValueB }}</td>
          <!-- <td class="body-lable">{{ item.indicatorValueC }}</td> -->
          <td class="body-lable">
            <c-progress
              class="c-progress"
              height="1.1rem"
              style="margin-top:.45rem"
              :num="percentage(item.indicatorValueC * 1).toFixed(2)"
            ></c-progress>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import common from '@/mixins/common.js'
export default {
  name: 'ETable',
  mixins: [common],
  props: {
    data: {
      default: () => [],
      type: Array
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  watch: {

  },
  methods: {

  },
  components: {

  }
}
</script>

<style scoped lang="stylus">
.table-item
  padding .6rem 1rem
  vertical-align middle !important
  .table-head
    overflow hidden
    .head-item
      height 1.2rem
      line-height 1.2rem
      background-image linear-gradient(to right, #005EFF, #1896FF)
      color #ffffff
      font-size .7rem
      text-align center
      border-right 2px solid #1c1839
  .head-item:last-child
    border-right 0
    border-radius 0 .3rem .3rem 0
  .head-item:first-child
    margin-left 0
    border-radius .3rem 0 0 .3rem
  .table-body
    .table-line
      text-align center
      line-height 1.2rem
      color rgba(255, 255, 255, .6)
      font-size .7rem
      .body-lable
        overflow hidden
        background #1F1E44
        border-right 2px solid #1c1839
        position relative
        white-space nowrap
      .body-lable:after
        height 1px
        border-bottom 1px solid rgba(255, 255, 255, .1)
        position absolute
        left 0
        bottom 0
        width 100%
        content ''
    .table-line:last-child .body-lable:after
      display none
    .body-lable:last-child
      border-right 0
    .vacancy
      height 5px
      overflow hidden
.border-none:after
  display none
>>>.unit-box--custom
  .unit-header__icon
    right 5.2rem
  .unit-header .title-slot
    float right
    display inline-block
    // padding-right 3rem
.table-body
  padding .5rem 1rem
</style>
